import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";

interface Option {
    value: string;
    label: string;
}

interface SelectDropdownProps {
    options: Option[]; // Array of options for the dropdown
    placeholder?: string; // Placeholder text
    name?: string;
    value?: string; // Controlled value for the dropdown
    labelIcon?: any;
    label?: string;
    selectId?: string;
    register?: any;
    setValue?: any;
}

const SelectDropdown = ({
    options,
    label,
    name,
    labelIcon,
    selectId,
    placeholder = "Select an option",
    value: controlledValue,
    register,
    setValue,
}: SelectDropdownProps) => {

    const [selectedValue, setSelectedValue] = useState(controlledValue);
    const [isOpen, setIsOpen] = useState(false); // State to toggle dropdown visibility

    const handleSelect = (optionValue: string) => {
        setSelectedValue(optionValue);
        setValue(name, optionValue, { shouldValidate: true });
        setIsOpen(false); // Close the dropdown
    };

    // Get the label of the selected value
    const selectedLabel = options.find((option) => option.value === selectedValue || option.value === controlledValue)?.label || placeholder;

    return (
        <div className="relative inline-block w-full">
            {label && <label htmlFor={selectId} className={`text-md mb-2 font-medium text-gray-700 ${labelIcon ? 'flex items-center gap-2' : ''}`}>{label} {labelIcon && <span className="text-base">{labelIcon}</span>}</label>}
            {/* Hidden Input for React Hook Form */}
            <input
                type="hidden"
                value={controlledValue ?? selectedValue}
                {...register(name, { required: true })}
            />

            {/* Trigger button */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="form-control text-start w-full relative pr-8"
            >
                <span className="block truncate text-gray-700">{selectedLabel}</span>
                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600">
                    <FiChevronDown size={20} />
                </span>
            </button>

            {/* Dropdown options */}
            {isOpen && (
                <div className="absolute z-10 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-lg max-h-[200px] overflow-auto">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            onClick={() => handleSelect(option.value)}
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectDropdown;
